import styled, { keyframes } from 'styled-components';

// AllPhotosModal と閉じるアニメーションの尺を揃える
export { FADE_DURATION_MS } from './AllPhotosModal.styled';

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to   { opacity: 0; }
`;

export const Overlay = styled.div<{ $isClosing: boolean; $duration: number }>`
  position: fixed;
  inset: 0;
  z-index: ${({ theme }) => theme.zIndex.modal + 1}; /* 一覧モーダルより前面 */
  background-color: rgba(77, 77, 77, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: env(safe-area-inset-top) 0 env(safe-area-inset-bottom);
  animation: ${({ $isClosing }) => ($isClosing ? fadeOut : fadeIn)}
    ${({ $duration }) => $duration}ms ease forwards;
`;

// 写真カード（横幅いっぱい、モバイル想定）
export const Card = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  position: relative;
  height: 44px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
`;

export const HeaderDate = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
  color: #ffffff;
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: #ffffff;
  cursor: pointer;
`;

export const Photo = styled.img`
  display: block;
  /* 写真の縦横比を保ったまま全体を表示する。
     横型は幅いっぱい、縦型は max-height で頭打ちになり幅が自然に狭くなる。 */
  max-width: 100%;
  max-height: calc(100dvh - 160px); /* ヘッダー・保存ボタン・safe-area 分を確保 */
  width: auto;
  height: auto;
  margin: 0 auto; /* 幅が狭い縦型を中央寄せ */
  object-fit: contain;
  box-shadow: ${({ theme }) => theme.shadows.md};
`;

export const Footer = styled.div`
  padding: ${({ theme }) => theme.spacing.lg};
`;

// 共有シートが使えない環境で、端末の長押し保存へ利用者を導くヒント。
// 背景色は Overlay と同値で、重なることで一段濃く見える想定
export const LongPressHint = styled.p`
  /* 通常のフォント設定では1行に収まる。端末側の文字サイズ拡大で溢れないよう
     nowrap は指定せず、幅に収まらない場合は折り返させる */
  width: fit-content;
  max-width: 100%;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  background-color: rgba(77, 77, 77, 0.8);
  border-radius: 8px;
  color: #ffffff;
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  line-height: 1.5; /* theme に 1.5 の lineHeight トークンが無いため設計値を直指定 */
  text-align: center;
`;

export const SaveButton = styled.button`
  width: 100%;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px 12px;
  background-color: ${({ theme }) => theme.colors.primary};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: 8px;
  color: #ffffff;
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  box-shadow: ${({ theme }) => theme.shadows.md};
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;
